/**
 * Redirects non-admin users to home. Use at the top of an admin-only page
 * or panel so the gating logic stays consistent in one place.
 *
 * Returns `loading` so the caller can render a spinner until the auth state
 * is known.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

export function useAdminGuard(): { loading: boolean; isAdmin: boolean } {
  const navigate = useNavigate();
  const { isAdmin, loading } = useUser();

  useEffect(() => {
    if (!loading && !isAdmin) navigate('/');
  }, [loading, isAdmin, navigate]);

  return { loading, isAdmin };
}
